import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Swal from "sweetalert2";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import FormFields from "./components/FormFields";

import { addNewRevendeurApi } from "api/revendeur";

const initialFormValue = {
  eventID: null,
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  pseudo: "",
  password: "",
  confirmPass: "",
  fromProduced: null,
};

function NewRevendeur() {
  const navigate = useNavigate();

  const [formValue, setFormValue] = useState(initialFormValue);

  const handleGetFormValues = (formFieldsProp) => {
    setFormValue(formFieldsProp);
  };

  const handleAddNewRevendeur = async () => {
    try {
      const revendeurData = {
        eventID: formValue?.eventID ?? null,
        firstName: formValue?.firstName ?? "",
        lastName: formValue?.lastName ?? "",
        email: formValue?.email ?? "",
        phone: formValue?.phone ?? "",
        pseudo: formValue?.pseudo ?? "",
        password: formValue?.password ?? "",
        confirmPass: formValue?.confirmPass ?? "",
        fromProduced: formValue?.fromProduced ?? null,
      };

      await addNewRevendeurApi(revendeurData);

      Swal.fire({
        title: "Création réussie",
        text: "Le nouveau revendeur a été ajouté avec succès.",
        icon: "success",
      });

      navigate(`/revendeurs/voir`);
    } catch (err) {
      console.error(
        "Erreur lors de l'ajout du nouveau revendeur:",
        err.response?.data?.error || err.message
      );
      toast.error(
        err.response?.data?.error || "Une erreur s'est produite lors de l'ajout du revendeur."
      );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                Ajouter un revendeur
              </MDTypography>
              <MDBox mt={1} mb={2}>
                <MDTypography variant="body2" color="text"></MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                <MDButton variant="gradient" color="info" onClick={handleAddNewRevendeur}>
                  {" "}
                  Ajouter un revendeur
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormFields formValues={handleGetFormValues} />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </DashboardLayout>
  );
}

export default NewRevendeur;
